import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ScopedTooltip, TooltipDecoratorProps } from '../TooltipDecorator/ScopedTooltip';

import './TooltipWrapper.css';

export type TooltipWrapperProps = TooltipDecoratorProps & {
    tooltipContent: React.ReactNode;
};

interface TooltipWrapperState {
    isVisible: boolean;
}

export class TooltipWrapper extends React.PureComponent<TooltipWrapperProps, TooltipWrapperState> {
    private anchor = React.createRef<HTMLDivElement>();

    constructor(props: TooltipWrapperProps) {
        super(props);

        this.state = {
            isVisible: false
        };
    }

    componentDidMount() {
        this.setState({
            isVisible: Boolean(this.props.visible)
        });
    }

    componentDidUpdate(prevProps: Readonly<TooltipWrapperProps>) {
        const isVisible = Boolean(this.props.visible);

        if (this.state.isVisible !== isVisible) {
            this.setState({
                isVisible
            });
        }
    }

    render() {
        const { tooltipContent, children, ...props } = this.props;

        return (
            <div ref={this.anchor} className={classNames(Bem.cls('tooltip-wrapper'))}>
                {children}
                <ScopedTooltip
                    cls={Bem.cls('tooltip-wrapper', 'tooltip')}
                    {...{
                        ...props,
                        anchor: this.anchor.current,
                        visible: this.state.isVisible
                    }}
                >
                    {tooltipContent}
                </ScopedTooltip>
            </div>
        );
    }
}
